import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
  TextField
} from '@mui/material';

interface Props {
  showModalLicenseExpirationDate: boolean;
  closeModal: Function;
  onChangeActivated: boolean,
  newLicenseExpirationDate: string | null;
  newLicenseActivationDate: string | null;
  currentExpirationDate: string;
  currentActivationDate: string;
  onChangeActivationDate: (date: string | null) => void;  
  onChangeExpirationDate: (date: string | null) => void; 
  
  handleSubmitLicenseExpirationDate: Function;
}

const ExpirationDateModal = ({
  showModalLicenseExpirationDate,
  closeModal,
  newLicenseExpirationDate,
  newLicenseActivationDate,
  onChangeActivationDate, 
  onChangeExpirationDate, 
  handleSubmitLicenseExpirationDate
}: Props) => {
  const { t } = useTranslation();

  const [activationDate, setActivationDate] = useState(newLicenseActivationDate || null);
  const [expirationDate, setExpirationDate] = useState(newLicenseExpirationDate || null);

  useEffect(() => {
    setActivationDate(newLicenseActivationDate);
    setExpirationDate(newLicenseExpirationDate);
  }, [newLicenseActivationDate, newLicenseExpirationDate]);

  const handleClearActivationDate = () => {
    onChangeActivationDate(null); 
    setActivationDate(null);
  };

  const handleClearExpirationDate = () => {
    onChangeExpirationDate(null);
    setExpirationDate(null);
  };

  const dialogWidth = '800px'; 
  const dialogHeight = '600px'; 
  const contentWidth = '600px';
  const contentHeight = '500px';

  return (
    <Dialog
      maxWidth="md"
      className="dialog"
      open={showModalLicenseExpirationDate}
      onClose={() => closeModal()}
      style={{
        // eslint-disable-next-line max-len
        width: dialogWidth, height: dialogHeight, paddingBottom:'40px', overflow: 'hidden', marginLeft: 'auto', marginRight: 'auto', top: '30%' 
      }}
    >
      <DialogTitle>{t('CHANGE_LICENSE_EXPIRATION_DATE')}</DialogTitle>
      <DialogContent className="content" style={{ width: contentWidth, height: contentHeight }}>
        <div className="datepicker-container" style={{ marginBottom: '16px' }}>
          <Typography>{t('NEW_ACTIVATION_DATE')}</Typography>
          <div className="datepicker-input-container">
            <TextField
              id="activation-date"
              type="date"
             
              style={{ width: '250px' }}
              value={activationDate || ''}
              onChange={(e) => {
                const value = e.target.value || null;

                onChangeActivationDate(value);
                setActivationDate(value);
              }}
              InputLabelProps={{
                shrink: true
              }}
              inputProps={{
                max: expirationDate || null
              }}
            />
            {activationDate && (
              <button className="clear-button" onClick={handleClearActivationDate} style={{ marginLeft: '36px' }}>
                {t('CLEAR')}
              </button>
            )}
          </div>
        </div>
          <div className="datepicker-container">
            <Typography>{t('NEW_EXPIRATION_DATE')}</Typography>
            <div className="datepicker-input-container" style={{ marginBottom: '16px' }}>
              <TextField
                id="expiration-date"
                type="date"
                style={{ width: '250px' }}
                value={expirationDate || ''}
                onChange={(e) => {
                  const value = e.target.value || null;
                  onChangeExpirationDate(value);
                  setExpirationDate(value);
                }}
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{
                  min: activationDate || null
                }}
              />
              {expirationDate && (
                <button className="clear-button" onClick={handleClearExpirationDate} style={{ marginLeft: '36px' }}>
                  {t('CLEAR')}
                </button>
              )}
            </div>
          </div>
          <Button
            variant="contained"
            style={{ padding: '16px', marginTop: '16px' }}
            onClick={() => handleSubmitLicenseExpirationDate()}
          >
            {t('SUBMIT')}
          </Button>
        </DialogContent>
      </Dialog>
  );
};

export default ExpirationDateModal;
